export const labelsFor = (language) => String(language || '').startsWith('ru') ? {
  refresh: 'Сверить результат Didit', busy: 'Сверяем…',
} : { refresh: 'Refresh Didit result', busy: 'Refreshing…' };
